import React from 'react';
import Paper from '@material-ui/core/Paper';
import {displayCost , displayUsage} from '../../../../helpers/helper';
import ArrowImage from '../../../../img/arrow-up-1.svg';
import { USAGE_TYPE, UNITS } from '../../../../constants/common';

export default function UsageSummary(props) {
  const displayValue = props.configs.data['usageSummaryWidget.displayValue'];
  const minThreshold = props.configs.data['usageSummaryWidget.thresholdToDisplayDifference'] || 0;
  const usageValue = (displayValue === USAGE_TYPE.COST ? (displayCost({cost: (props.usageSummaryData && props.usageSummaryData.cost ? props.usageSummaryData.cost : 0), round: true, showCurrency:true })) : displayUsage({usage: (props.usageSummaryData && props.usageSummaryData.consumption ? props.usageSummaryData.consumption : 0), round: true, showUsageUnit: true, fuelType: props.configs.data.fuelType }));
  const previousUsageValue = (displayValue === USAGE_TYPE.COST ? displayCost({cost: (Math.abs(props.usageSummaryData && props.usageSummaryData.previousBillCycleCostDifference ? props.usageSummaryData.previousBillCycleCostDifference : 0)), round: true, showCurrency:true}) : displayUsage({usage: (Math.abs(props.usageSummaryData && props.usageSummaryData.previousBillCycleConsumptionDifference ? props.usageSummaryData.previousBillCycleConsumptionDifference : 0)), round: true, showUsageUnit: true, fuelType: props.configs.data.fuelType }));

  return(
    <Paper className="bp-and-usage-summary-widget usage-summary-container">
      <div className="summary-header-container">
        <div className="summary-header-title">
          <span className="summary-title-main">{props.translations["HOME.USAGE_SUMMARY.USAGE_SUMMARY"]}</span>
          <span className="bill-period">{props.usageSummaryData && props.usageSummaryData.billStartDate && props.usageSummaryData.billEndDate && (
            <>
              {props.usageSummaryData.billStartDate} - {props.usageSummaryData.billEndDate}
            </>
          )} ({props.translations["HOME.USAGE_SUMMARY.LAST_PERIOD"]})</span>
        </div>
      </div>
      <div className="summary-container">
        <div className="usage">
          <span className="summary-title">{displayValue === USAGE_TYPE.COST ? props.translations["HOME.USAGE_SUMMARY.AMOUNT"] : props.translations["HOME.USAGE_SUMMARY_CONSUMPTION"]}</span>
          <span className="usage-value">{usageValue}</span>
          <span className="summary-detail">{displayValue === USAGE_TYPE.COST ? (props.usageSummaryData && props.usageSummaryData.consumption ? props.usageSummaryData.consumption + ' ' + UNITS.kWh : 0 + ' ' + UNITS.kWh) : ''} </span>
        </div>
        {(props.usageSummaryData) && (props.usageSummaryData.previousBillCycleCostDifference) && (Math.abs(props.usageSummaryData.previousBillCycleCostDifference) >= minThreshold) ? (
          <div className="usage">
            <span className="summary-title">{props.translations["HOME.USAGE_SUMMARY.VS_PREVIOUS_BILL"]}</span>
            <span className="usage-value">
              <img src={ArrowImage} alt="arrow" className={(props.usageSummaryData.previousBillCycleCostDifference < 0) ? "invert" : " " } />
              {previousUsageValue}
            </span>
            <span className="summary-detail">{props.usageSummaryData.previousBillCycleConsumptionPercentageDifferenceText}</span>
          </div>
        ) : ''}
      </div>
      {props.usageSummaryError && (
        <div className="home-api-error">{props.translations["HOME.USAGE_SUMMARY.API_ERROR"]}</div>
      )}
    </Paper>
  );
}
